import { render } from "./Venue.vue?vue&type=template&id=41165681&scoped=true"
import script from "./Venue.vue?vue&type=script&lang=js"
export * from "./Venue.vue?vue&type=script&lang=js"

import "./Venue.vue?vue&type=style&index=0&id=41165681&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41165681"

export default script